// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__2mFsk","text_dark":"Tag_text_dark__2xAGf","text_light":"Tag_text_light__9Gydr","selected":"Tag_selected__NAzZM","item_tag":"Tag_item_tag__2DL0V"};